<template>
  <section class="notice-belt nb-choco">
    <div class="notice-text2 row d-flex justify-content-center">
      <div class="col-2" style="text-align: end">
        <div class="notice-text">NOTICE ></div>
      </div>
      <div class="col-auto" v-for="item in items" :key="item.id">
        <ul>
          <li>
            <a :href="`/p/NoticeRead/${item.id}`">{{ item.title }} - {{ date_today_yyyymmdd(item.date) }}</a>
          </li>
        </ul>
      </div>
      <div class="col-2">
        <a href="/p/Notice" class="btn-view-more"><span>VIEW MORE</span></a>
      </div>
    </div>
  </section>
</template>

<script>
import boardService from '@/services/board.service';
import GeneralUtil from '@/util/GeneralUtil';
import MY_BID from '@/services/boardIds';
export default {
  name: 'NoticeBar',
  mixins: [GeneralUtil],
  data() {
    return {
      items: [],
    };
  },
  async beforeCreate() {
    // {
    //   id: 0,
    //   title: '국내 최고 골프장에 선정된 핀크스 골프클럽',
    //   date: '2021-12-31',
    //   image: 'main_newsroom_sample01.jpg',
    // },

    const aList = await boardService.getArticleList(MY_BID.NOTICE, 1, 2, 'BoardArticleSummary');

    console.log(aList);

    this.items = aList._embedded.boardArticles.map(x => ({
      id: x.id,
      title: x.title,
      date: x.startDate,
    }));
  },
};
</script>

<style scoped>
.notice-belt.nb-choco {
  background-color: #2d2d2d;
}

.notice-text {
  color: white;
}

a {
  color: white;
}

.notice-text2 {
  font-size: 0.8em;
  height: 50px;
  line-height: 50px;
}

ul {
  list-style-type: none;
}

@media (max-width: 992px) {
  .notice-belt {
    display: none;
    height: 50px;
    background-color: #0a1909;
  }
}

@media (min-width: 992px) {
  .notice-belt {
    display: block;
    height: 50px;
    background-color: #0a1909;
  }
}

@media (min-width: 1200px) {
  .notice-belt {
    display: block;
    height: 50px;
    background-color: #0a1909;
  }
}
</style>
